import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 1 }
const _hoisted_2 = {
  ref: "carousel",
  class: "carousel-container"
}
const _hoisted_3 = { id: "aboutMe" }
const _hoisted_4 = { id: "studies" }
const _hoisted_5 = { id: "expertises" }
const _hoisted_6 = { id: "affiliations" }
const _hoisted_7 = { id: "contacts" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TeoPathNavBar = _resolveComponent("TeoPathNavBar")!
  const _component_ServicesCarousel = _resolveComponent("ServicesCarousel")!
  const _component_AboutMeView = _resolveComponent("AboutMeView")!
  const _component_StudiesView = _resolveComponent("StudiesView")!
  const _component_ExpertisesView = _resolveComponent("ExpertisesView")!
  const _component_AffiliationsView = _resolveComponent("AffiliationsView")!
  const _component_ContactsView = _resolveComponent("ContactsView")!
  const _component_ScrollToTopArrow = _resolveComponent("ScrollToTopArrow")!
  const _component_WhatsAppIcon = _resolveComponent("WhatsAppIcon")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.scrolledPastCarousel)
      ? (_openBlock(), _createBlock(_component_TeoPathNavBar, {
          key: 0,
          ref: "navbar",
          scrolledPastCarousel: _ctx.scrolledPastCarousel
        }, null, 8, ["scrolledPastCarousel"]))
      : _createCommentVNode("", true),
    (_ctx.isHomeView)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_ServicesCarousel, { scrolledPastCarousel: _ctx.scrolledPastCarousel }, null, 8, ["scrolledPastCarousel"])
          ], 512),
          _createElementVNode("section", _hoisted_3, [
            _createVNode(_component_AboutMeView)
          ]),
          _createElementVNode("section", _hoisted_4, [
            _createVNode(_component_StudiesView)
          ]),
          _createElementVNode("section", _hoisted_5, [
            _createVNode(_component_ExpertisesView)
          ]),
          _createElementVNode("section", _hoisted_6, [
            _createVNode(_component_AffiliationsView)
          ]),
          _createElementVNode("section", _hoisted_7, [
            _createVNode(_component_ContactsView)
          ]),
          _createVNode(_component_ScrollToTopArrow),
          _createVNode(_component_WhatsAppIcon, { "phone-number": "447947572606" })
        ]))
      : (_openBlock(), _createBlock(_component_router_view, { key: 2 }))
  ], 64))
}